import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

/* ─── Data ─── */
const DESTINATIONS = [
  { name:'Srinagar',    count:'12 Packages', img:'https://images.unsplash.com/photo-1719423521976-2fea6202adbc?w=800&q=80', height:'340px' },
  { name:'Gulmarg',     count:'8 Packages',  img:'https://images.unsplash.com/photo-1627894485200-b92fb4353967?w=800&q=80', height:'220px' },
  { name:'Pahalgam',    count:'7 Packages',  img:'https://images.unsplash.com/photo-1661747340818-df15f186554e?w=800&q=80', height:'220px' },
  { name:'Sonamarg',    count:'5 Packages',  img:'https://images.unsplash.com/photo-1706628416838-0325e29521ee?w=800&q=80', height:'220px' },
  { name:'Ladakh',      count:'6 Packages',  img:'https://images.unsplash.com/photo-1635255506105-b74adbd94026?w=800&q=80', height:'220px' },
  { name:'Doodhpathri', count:'3 Packages',  img:'https://images.unsplash.com/photo-1623612175509-30e97f5aa195?w=800&q=80', height:'180px' },
];

const FEATURES = [
  { icon:'🏠', label:'Luxury Houseboats',  desc:'Handpicked premium houseboats on the iconic Dal Lake with modern amenities.', bg:'icon-primary' },
  { icon:'🚗', label:'Private Transfers',  desc:'Exclusive AC vehicles, experienced drivers & GPS tracking for all routes.', bg:'icon-secondary' },
  { icon:'🧭', label:'Expert Local Guides', desc:'Certified guides with 10+ years of expertise sharing untold Kashmir stories.', bg:'icon-accent' },
  { icon:'⭐', label:'Best Price Guarantee',desc:'Transparent pricing, no hidden fees. Best rates or we match competitors.', bg:'icon-success' },
  { icon:'📞', label:'24×7 Support',        desc:'Dedicated support team available round the clock for a worry-free trip.', bg:'icon-primary' },
  { icon:'🗺️', label:'Custom Itineraries', desc:'Every journey tailored to your pace, preferences and travel dreams.', bg:'icon-secondary' },
];

const HOUSEBOATS = [
  { name:'Royal Heritage Houseboat', lake:'Dal Lake, Srinagar', price:'₹4,999/night', rating:4.9, reviews:124, amenities:['Lake View','WiFi','Heater','Luxury Bedroom','Private Balcony','Room Service'], img:'https://images.unsplash.com/photo-1595815771614-ade9d652a65d?w=800&q=80', badge:'Most Popular' },
  { name:'Nagin Lake Palace',        lake:'Nagin Lake, Srinagar',price:'₹6,499/night', rating:4.8, reviews:89,  amenities:['Panoramic View','WiFi','Hot Water','Dining Hall','Shikara Ride','AC'],    img:'https://images.unsplash.com/photo-1614591276564-7b3e69347a48?w=800&q=80', badge:'Premium' },
  { name:'The Lake Garden Suite',    lake:'Dal Lake, Srinagar', price:'₹3,499/night', rating:4.7, reviews:67,  amenities:['Garden View','WiFi','Heater','Breakfast','Shikara Ride','Parking'],          img:'https://images.unsplash.com/photo-1656343058836-ebc766a32a51?w=800&q=80', badge:'Best Value' },
];

const TAXIS = [
  { icon:'🚗', name:'Sedan',           seats:'4 Seats',  desc:'Dzire / Etios — perfect for couples & small families', popular:false },
  { icon:'🚙', name:'SUV / Innova',    seats:'6-7 Seats',desc:'Toyota Innova — the Kashmir favourite for comfort',     popular:true  },
  { icon:'🏎️', name:'Luxury SUV',     seats:'6-7 Seats',desc:'Fortuner / Scorpio — premium travel in style',          popular:false },
  { icon:'🚐', name:'Tempo Traveller', seats:'12 Seats', desc:'Ideal for group tours & family reunions',               popular:false },
  { icon:'🚌', name:'Mini Bus',        seats:'20 Seats', desc:'Corporate & large group travel solutions',              popular:false },
];

const ACTIVITIES = [
  { name:'Shikara Ride',    img:'https://images.unsplash.com/photo-1564327287902-0ccf559d839e?w=400&q=80' },
  { name:'Gondola Ride',    img:'https://images.unsplash.com/photo-1568889753852-196c487a536e?w=400&q=80' },
  { name:'Horse Riding',    img:'https://images.unsplash.com/photo-1643449415972-87d4cfe882a1?w=400&q=80' },
  { name:'River Rafting',   img:'https://images.unsplash.com/photo-1661747340818-df15f186554e?w=400&q=80' },
  { name:'Snow Activities', img:'https://images.unsplash.com/photo-1651509094074-e8acaeb84d8f?w=400&q=80' },
  { name:'Camping',         img:'https://images.unsplash.com/photo-1624880099342-7404ea1bc666?w=400&q=80' },
  { name:'Photography',     img:'https://images.unsplash.com/photo-1708070642298-166c0af7a12d?w=400&q=80' },
  { name:'Local Shopping',  img:'https://images.unsplash.com/photo-1685716271205-83a5ac2ba63b?w=400&q=80' },
];

const TESTIMONIALS = [
  { name:'Priya & Rahul Sharma', role:'Honeymoon Couple · Delhi', rating:5, text:'Our Kashmir honeymoon was pure magic. The houseboat on Dal Lake, the shikara ride at sunrise, Gulmarg in snow — every moment was beyond our imagination. The team handled everything flawlessly.', avatar:'https://i.pravatar.cc/150?img=47' },
  { name:'Vikram Mehta', role:'Family of 6 · Mumbai', rating:5, text:'Booked a 5-night Kashmir package for my parents and kids. The driver was incredibly professional, the hotel was stunning, and our guide Imran\'s knowledge was priceless. Will book again for Ladakh!', avatar:'https://i.pravatar.cc/150?img=32' },
  { name:'Anita & Suresh Patel', role:'Anniversary Trip · Ahmedabad', rating:5, text:'We were nervous about travelling to Kashmir but the team reassured us at every step. The 4-night itinerary was perfectly paced. Pahalgam\'s Betaab Valley took our breath away.', avatar:'https://i.pravatar.cc/150?img=44' },
  { name:'Rohan Gupta', role:'Solo Traveller · Bangalore', rating:5, text:'Solo trip to Ladakh — best decision of my life. The inner-line permits, camp stays at Pangong, crossing Khardung La — the logistics were handled without a single hiccup. Highly recommend!', avatar:'https://i.pravatar.cc/150?img=12' },
  { name:'The Kumar Family', role:'Group of 8 · Hyderabad', rating:5, text:'Group tour for 8 people including elderly parents. The Tempo Traveller was spotless, AC worked even in high passes, and the custom itinerary perfectly balanced adventure with relaxation.', avatar:'https://i.pravatar.cc/150?img=38' },
  { name:'Neha Kapoor', role:'Corporate Group · Pune', rating:5, text:'Organised a 20-person corporate retreat to Kashmir. Flawless coordination, premium hotel stay, authentic Wazwan dinner, and the team was available 24/7. Standing ovation from my colleagues!', avatar:'https://i.pravatar.cc/150?img=5' },
];

const FAQS = [
  { q:'What is the best time to visit Kashmir?', a:'Kashmir is beautiful year-round. Spring (March–May) brings tulip gardens in bloom. Summer (June–August) is ideal for Sonamarg & Pahalgam. Autumn (Sep–Nov) offers golden chinar leaves. Winter (Dec–Feb) transforms Gulmarg into a ski paradise.' },
  { q:'Do you offer customised tour packages?', a:'Absolutely! Every itinerary is tailored to your group size, budget, travel dates, and interests — whether it\'s a honeymoon, family trip, adventure tour, or corporate retreat. Contact us with your requirements and we\'ll craft the perfect package.' },
  { q:'Is it safe to travel to Kashmir?', a:'Yes. Kashmir is safe and millions of tourists visit annually. We monitor ground conditions daily, maintain emergency contacts throughout the valley, and provide 24/7 support so you can travel with complete confidence.' },
  { q:'What documents are required for travel to Ladakh?', a:'Indian nationals need a valid photo ID. Foreign nationals require inner-line permits (ILP) for certain restricted areas like Pangong, Nubra Valley, etc. We arrange all required permits as part of our package — you don\'t need to worry about paperwork.' },
  { q:'Are your houseboats comfortable and clean?', a:'All our listed houseboats are personally inspected and rated. They feature heated rooms, clean bathrooms, WiFi, daily housekeeping, and freshly cooked traditional Kashmiri meals. Many houseboats are certified by J&K Tourism.' },
  { q:'What is your cancellation policy?', a:'Free cancellation up to 15 days before travel. 50% refund between 8–14 days. No refund within 7 days. However, we offer flexible rescheduling at no extra cost for most packages if you inform us in advance.' },
];

/* ─── Counter Hook ─── */
function useCounter(target, duration = 2000) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        let start = 0;
        const step = target / (duration / 16);
        const timer = setInterval(() => {
          start += step;
          if (start >= target) { setCount(target); clearInterval(timer); }
          else setCount(Math.floor(start));
        }, 16);
        observer.disconnect();
      }
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target, duration]);
  return [count, ref];
}

/* ─── Stat Item ─── */
function StatItem({ value, suffix, label, ratingMode }) {
  const [count, ref] = useCounter(value);
  const display = ratingMode
    ? `${(count / 10).toFixed(1)}★`
    : `${count}${suffix}`;
  return (
    <div ref={ref} className="stat-item">
      <div className="stat-number">{display}</div>
      <div className="stat-label">{label}</div>
    </div>
  );
}

/* ─── FAQ Item ─── */
function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq-item${open ? ' open' : ''}`}>
      <div className="faq-question" onClick={() => setOpen(o => !o)}>
        <span>{q}</span>
        <span className="faq-icon">+</span>
      </div>
      <div className="faq-answer">{a}</div>
    </div>
  );
}

/* ─── Main Component ─── */
export default function Home() {
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchState, setSearchState] = useState({ destination:'', date:'', guests:'', nights:'' });
  const [scrollTop, setScrollTop] = useState(false);

  useEffect(() => {
    axios.get('/api/tours?featured=true').then(r => setTours(r.data)).catch(() => {}).finally(() => setLoading(false));
    const onScroll = () => setScrollTop(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    // Scroll reveal
    const reveal = () => document.querySelectorAll('.reveal').forEach(el => {
      if (el.getBoundingClientRect().top < window.innerHeight - 80) el.classList.add('visible');
    });
    window.addEventListener('scroll', reveal, { passive: true });
    reveal();
    return () => { window.removeEventListener('scroll', onScroll); window.removeEventListener('scroll', reveal); };
  }, []);

  return (
    <div style={{ background:'var(--bg)' }}>

      {/* ══ HERO ══ */}
      <section style={{ position:'relative', height:'100vh', minHeight:700, display:'flex', flexDirection:'column', justifyContent:'center', overflow:'hidden', background:'#0F2542' }}>
        {/* Background */}
        <div style={{ position:'absolute', inset:0 }}>
          <img src="https://images.unsplash.com/photo-1715457573748-8e8a70b2c1be?w=1800&q=85" alt="Kashmir Dal Lake" style={{ width:'100%', height:'100%', objectFit:'cover', opacity:0.75 }} />
          <div style={{ position:'absolute', inset:0, background:'linear-gradient(160deg, rgba(10,25,55,0.65) 0%, rgba(10,25,55,0.50) 40%, rgba(10,25,55,0.70) 100%)' }} />
        </div>

        <div className="container" style={{ position:'relative', zIndex:2, paddingTop:'80px' }}>
          {/* Label */}
          <div style={{ display:'inline-flex', alignItems:'center', gap:'0.5rem', background:'rgba(246,196,83,0.18)', backdropFilter:'blur(10px)', border:'1px solid rgba(246,196,83,0.35)', borderRadius:100, padding:'0.4rem 1rem', marginBottom:'1.5rem' }}>
            <span style={{ color:'var(--accent)', fontSize:'0.78rem', fontWeight:700, fontFamily:"'Poppins',sans-serif", letterSpacing:'0.12em', textTransform:'uppercase' }}>✦ Award-winning Kashmir Travel Company</span>
          </div>

          {/* Headline */}
          <h1 style={{ color:'#fff', fontFamily:"'Playfair Display',serif", fontWeight:800, fontSize:'clamp(2.4rem,5.5vw,4.2rem)', lineHeight:1.1, maxWidth:720, marginBottom:'1.25rem', textShadow:'0 2px 24px rgba(0,0,0,0.7), 0 1px 8px rgba(0,0,0,0.5)' }}>
            Discover Paradise.<br/>
            <span style={{ fontStyle:'italic', color:'var(--accent)' }}>Travel in Luxury.</span>
          </h1>

          <p style={{ color:'rgba(255,255,255,0.95)', fontSize:'1.1rem', maxWidth:560, lineHeight:1.7, marginBottom:'2rem', textShadow:'0 1px 8px rgba(0,0,0,0.5)' }}>
            Kashmir — where the Himalayas meet paradise. Experience world-class houseboats, private tours, and memories that last a lifetime.
          </p>

          {/* CTAs */}
          <div style={{ display:'flex', gap:'1rem', flexWrap:'wrap', marginBottom:'3rem' }}>
            <Link to="/tours" className="btn btn-accent btn-lg">✦ Explore Packages</Link>
            <a href="https://wa.me/919876543210" target="_blank" rel="noopener noreferrer" className="btn btn-ghost btn-lg">
              💬 Talk to Expert
            </a>
          </div>

          {/* Search Widget */}
          <div className="search-widget" style={{ maxWidth:820 }}>
            <div className="search-field">
              <span className="search-label">Destination</span>
              <input className="search-input" placeholder="Where do you want to go?" value={searchState.destination} onChange={e => setSearchState(s => ({...s, destination:e.target.value}))} />
            </div>
            <div className="search-divider" />
            <div className="search-field">
              <span className="search-label">Travel Date</span>
              <input className="search-input" type="date" value={searchState.date} onChange={e => setSearchState(s => ({...s, date:e.target.value}))} />
            </div>
            <div className="search-divider" />
            <div className="search-field">
              <span className="search-label">Guests</span>
              <input className="search-input" placeholder="2 Adults, 1 Child" value={searchState.guests} onChange={e => setSearchState(s => ({...s, guests:e.target.value}))} />
            </div>
            <Link to={`/tours?destination=${searchState.destination}&date=${searchState.date}`} className="btn btn-primary btn-lg search-btn" style={{ whiteSpace:'nowrap' }}>
              🔍 Search
            </Link>
          </div>
        </div>

      </section>

      {/* ══ STATS BAR ══ */}
      <div style={{ background:'#0d2a22', padding:'2rem clamp(1rem,4vw,2.5rem)' }}>
        <div style={{ maxWidth:1320, margin:'0 auto' }}>
          <div className="stats-bar">
            <StatItem value={5000}  suffix="+" label="Happy Travellers" />
            <StatItem value={14}    suffix="+" label="Years Experience" />
            <StatItem value={50}    suffix="+"  label="Tour Packages" />
            <StatItem value={49}    suffix="" label="Average Rating" ratingMode />
          </div>
        </div>
      </div>

      {/* ══ TRUST BAR ══ */}
      <div style={{ background:'var(--surface)', padding:'1.5rem 0', borderBottom:'1px solid var(--border)' }}>
        <div className="container">
          <div className="trust-bar">
            <div className="trust-item"><span>⭐</span> 4.9/5 on Google (800+ Reviews)</div>
            <div className="trust-item"><span>🏆</span> TripAdvisor Certificate of Excellence</div>
            <div className="trust-item"><span>✅</span> J&K Tourism Verified</div>
            <div className="trust-item"><span>🔒</span> 100% Secure Booking</div>
            <div className="trust-item"><span>💯</span> Money-Back Guarantee</div>
          </div>
        </div>
      </div>

      {/* ══ WHY CHOOSE US ══ */}
      <section className="section" style={{ background:'var(--bg)' }}>
        <div className="container">
          <div className="section-header text-center reveal">
            <span className="section-label">Why Choose Us</span>
            <h2 className="section-title">The Kashmir Luxury<br/>Difference</h2>
            <div className="divider divider-center" />
            <p className="section-subtitle">We don't just book trips — we craft life-changing experiences. Here's what makes us Kashmir's most trusted luxury travel partner.</p>
          </div>
          <div className="grid-3" style={{ gap:'1.5rem' }}>
            {FEATURES.map((f, i) => (
              <div key={i} className="feature-card reveal" style={{ animationDelay:`${i*0.08}s` }}>
                <div className={`feature-icon ${f.bg}`}>{f.icon}</div>
                <h4 style={{ fontFamily:"'Playfair Display',serif", fontWeight:700, color:'var(--heading)', marginBottom:'0.6rem' }}>{f.label}</h4>
                <p style={{ fontSize:'0.92rem', lineHeight:1.7, margin:0 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ DESTINATIONS ══ */}
      <section className="section" style={{ background:'var(--surface)', paddingTop:'5rem', paddingBottom:'5rem' }}>
        <div className="container">
          <div className="section-header text-center reveal">
            <span className="section-label">Top Destinations</span>
            <h2 className="section-title">Explore the Valley of<br/><span style={{ fontStyle:'italic', color:'var(--secondary)' }}>Paradise</span></h2>
            <div className="divider divider-center" />
          </div>
          {/* Bento-style grid */}
          <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gridTemplateRows:'auto', gap:'1rem' }}>
            {/* Big card left */}
            <div className="dest-card reveal" style={{ gridRow:'span 2', height:450 }}>
              <img src={DESTINATIONS[0].img} alt={DESTINATIONS[0].name} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
              <div className="dest-card-overlay">
                <div>
                  <div className="dest-card-name">{DESTINATIONS[0].name}</div>
                  <div className="dest-card-count">{DESTINATIONS[0].count}</div>
                </div>
              </div>
            </div>
            {/* Top-right 2 */}
            {DESTINATIONS.slice(1,3).map((d,i) => (
              <div key={i} className="dest-card reveal" style={{ height:215 }}>
                <img src={d.img} alt={d.name} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                <div className="dest-card-overlay">
                  <div>
                    <div className="dest-card-name">{d.name}</div>
                    <div className="dest-card-count">{d.count}</div>
                  </div>
                </div>
              </div>
            ))}
            {/* Bottom-right 3 */}
            {DESTINATIONS.slice(3).map((d,i) => (
              <div key={i} className="dest-card reveal" style={{ height:215 }}>
                <img src={d.img} alt={d.name} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                <div className="dest-card-overlay">
                  <div>
                    <div className="dest-card-name">{d.name}</div>
                    <div className="dest-card-count">{d.count}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ textAlign:'center', marginTop:'2.5rem' }}>
            <Link to="/destinations" className="btn btn-outline">View All Destinations →</Link>
          </div>
        </div>
      </section>

      {/* ══ PACKAGES ══ */}
      <section className="section" style={{ background:'var(--bg)' }}>
        <div className="container">
          <div className="section-header text-center reveal">
            <span className="section-label">Featured Packages</span>
            <h2 className="section-title">Handcrafted Kashmir<br/>Experiences</h2>
            <div className="divider divider-center" />
            <p className="section-subtitle">From romantic houseboats on Dal Lake to adventure treks in Ladakh — find the perfect journey for every traveller.</p>
          </div>

          {loading ? (
            <div className="grid-3">
              {[1,2,3].map(i => <div key={i} className="skeleton" style={{ height:380 }} />)}
            </div>
          ) : (
            <div className="grid-3">
              {tours.slice(0,6).map((tour,i) => (
                <div key={tour._id} className="tour-card reveal" style={{ animationDelay:`${i*0.1}s` }}>
                  <div className="tour-card-img">
                    <img src={tour.coverImage} alt={tour.title} loading="lazy" />
                    <div style={{ position:'absolute', top:'1rem', left:'1rem' }}>
                      <span className="badge badge-white">{tour.category === 'ladakh' ? '🏔️ Ladakh' : '🌿 Kashmir'}</span>
                    </div>
                    <div className="tour-card-price-badge">
                      ₹{tour.discountedPrice?.toLocaleString('en-IN')}
                    </div>
                  </div>
                  <div className="tour-card-body">
                    <div className="tour-card-meta">
                      <span>🕐 {tour.duration}</span>
                      <span>👥 Max {tour.maxGroupSize}</span>
                    </div>
                    <div className="tour-card-title">{tour.title}</div>
                    <div className="tour-card-dests">📍 {tour.destinations?.slice(0,3).join(' · ')}</div>
                    <div className="tour-card-footer">
                      <div className="tour-card-rating">
                        <span className="stars">★</span>
                        <span style={{ fontWeight:700, color:'var(--heading)' }}>{tour.rating}</span>
                        <span style={{ color:'var(--muted)', fontSize:'0.8rem' }}>({tour.reviewCount})</span>
                      </div>
                      <div style={{ display:'flex', alignItems:'center', gap:'0.6rem' }}>
                        {tour.price > tour.discountedPrice && (
                          <span style={{ textDecoration:'line-through', color:'var(--muted)', fontSize:'0.82rem' }}>₹{tour.price?.toLocaleString('en-IN')}</span>
                        )}
                        <Link to={`/tours/${tour.slug}`} className="btn btn-primary btn-sm">View Details</Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div style={{ textAlign:'center', marginTop:'3rem' }}>
            <Link to="/tours" className="btn btn-primary btn-lg">View All Packages →</Link>
          </div>
        </div>
      </section>

      {/* ══ HOUSEBOATS ══ */}
      <section className="section" style={{ background:'var(--dark)', position:'relative', overflow:'hidden' }}>
        <div style={{ position:'absolute', inset:0 }}>
          <img src="https://images.unsplash.com/photo-1596083332905-666e9acf8807?w=1600&q=75" alt="Dal Lake" style={{ width:'100%', height:'100%', objectFit:'cover', opacity:0.12 }} />
        </div>
        <div className="container" style={{ position:'relative', zIndex:1 }}>
          <div className="section-header text-center reveal">
            <span style={{ display:'inline-flex', alignItems:'center', gap:'0.5rem', fontFamily:"'Poppins',sans-serif", fontSize:'0.78rem', fontWeight:700, letterSpacing:'0.12em', textTransform:'uppercase', color:'var(--accent)', marginBottom:'0.75rem' }}>
              <span style={{ width:28, height:2, background:'var(--accent)', display:'inline-block', borderRadius:2 }} />
              Luxury Houseboats
            </span>
            <h2 className="section-title" style={{ color:'#fff' }}>Sleep on the Legendary<br/><span style={{ fontStyle:'italic', color:'var(--secondary)' }}>Dal Lake</span></h2>
            <div className="divider divider-center" />
            <p className="section-subtitle" style={{ color:'rgba(255,255,255,0.75)' }}>Wake up to misty mountain reflections on the shimmering lake. Our curated collection of luxury houseboats offer an unmatched romantic experience.</p>
          </div>
          <div className="grid-3">
            {HOUSEBOATS.map((h, i) => (
              <div key={i} className="houseboat-card reveal" style={{ animationDelay:`${i*0.12}s` }}>
                <div className="houseboat-img">
                  <img src={h.img} alt={h.name} loading="lazy" />
                  <div style={{ position:'absolute', top:'1rem', left:'1rem' }}>
                    <span className="badge badge-accent">{h.badge}</span>
                  </div>
                </div>
                <div className="houseboat-body">
                  <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.15rem', color:'var(--heading)', marginBottom:'0.3rem' }}>{h.name}</h3>
                  <p style={{ fontSize:'0.82rem', color:'var(--muted)', marginBottom:'0.1rem' }}>📍 {h.lake}</p>
                  <div className="houseboat-amenities">
                    {h.amenities.map((a,j) => <span key={j} className="amenity-tag">{a}</span>)}
                  </div>
                  <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                    <div>
                      <div style={{ fontWeight:700, fontSize:'1.2rem', color:'var(--primary)', fontFamily:"'Poppins',sans-serif" }}>{h.price}</div>
                      <div style={{ fontSize:'0.78rem', color:'var(--muted)' }}>⭐ {h.rating} ({h.reviews} reviews)</div>
                    </div>
                    <Link to="/houseboats" className="btn btn-secondary btn-sm">Book Now</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ textAlign:'center', marginTop:'2.5rem' }}>
            <Link to="/houseboats" className="btn btn-outline-white btn-lg">Explore All Houseboats →</Link>
          </div>
        </div>
      </section>

      {/* ══ TAXI SERVICES ══ */}
      <section className="section" style={{ background:'var(--surface)' }}>
        <div className="container">
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'4rem', alignItems:'center' }}>
            <div className="reveal">
              <span className="section-label">Private Transfers</span>
              <h2 className="section-title">Travel Kashmir in<br/><span style={{ fontStyle:'italic', color:'var(--secondary)' }}>Comfort & Style</span></h2>
              <div className="divider" />
              <p style={{ marginBottom:'1.5rem', lineHeight:1.8 }}>Our fleet of premium, well-maintained vehicles with experienced local drivers ensures every journey through Kashmir's breathtaking landscapes is as memorable as the destinations themselves.</p>
              <ul style={{ listStyle:'none', marginBottom:'2rem' }}>
                {['GPS tracked vehicles','Experienced local drivers','AC & Non-AC options','Airport / railway transfers','Hourly, daily & full-trip packages'].map((item,i) => (
                  <li key={i} style={{ display:'flex', alignItems:'center', gap:'0.7rem', padding:'0.5rem 0', fontSize:'0.92rem', color:'var(--body)', borderBottom:'1px solid var(--border)' }}>
                    <span style={{ color:'var(--success)', fontSize:'1rem' }}>✓</span>
                    {item}
                  </li>
                ))}
              </ul>
              <Link to="/contact" className="btn btn-primary btn-lg">Get a Free Quote</Link>
            </div>
            <div className="grid-2" style={{ gap:'1rem' }}>
              {TAXIS.map((t,i) => (
                <div key={i} className={`taxi-card reveal${t.popular ? '' : ''}`} style={{ position:'relative', animationDelay:`${i*0.08}s`, gridColumn: i===4 ? 'span 2' : '' }}>
                  {t.popular && <div style={{ position:'absolute', top:'-10px', left:'50%', transform:'translateX(-50%)', background:'var(--secondary)', color:'#fff', fontSize:'0.7rem', fontWeight:700, padding:'0.2rem 0.75rem', borderRadius:100, fontFamily:"'Poppins',sans-serif", letterSpacing:'0.05em', whiteSpace:'nowrap' }}>MOST POPULAR</div>}
                  <div className="taxi-icon">{t.icon}</div>
                  <div className="taxi-name">{t.name}</div>
                  <div className="taxi-seats">{t.seats}</div>
                  <p style={{ fontSize:'0.8rem', color:'var(--muted)', lineHeight:1.5, marginBottom:'1rem' }}>{t.desc}</p>
                  <Link to="/contact" className="btn btn-outline btn-sm w-full" style={{ justifyContent:'center' }}>Book</Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ══ ACTIVITIES ══ */}
      <section className="section" style={{ background:'var(--bg)' }}>
        <div className="container">
          <div className="section-header text-center reveal">
            <span className="section-label">Things To Do</span>
            <h2 className="section-title">Unforgettable Kashmir<br/><span style={{ fontStyle:'italic', color:'var(--secondary)' }}>Adventures</span></h2>
            <div className="divider divider-center" />
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'1rem' }}>
            {ACTIVITIES.map((a,i) => (
              <div key={i} className="activity-card reveal" style={{ animationDelay:`${i*0.06}s`, height:220 }}>
                <img src={a.img} alt={a.name} loading="lazy" />
                <div className="activity-overlay">
                  <span className="activity-name">{a.name}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ TESTIMONIALS ══ */}
      <section className="section" style={{ background:'var(--surface)' }}>
        <div className="container">
          <div className="section-header text-center reveal">
            <span className="section-label">Real Stories</span>
            <h2 className="section-title">Trusted by Thousands<br/>of Happy Travellers</h2>
            <div className="divider divider-center" />
            <p className="section-subtitle">Don't take our word for it. Here's what our travellers say about their unforgettable Kashmir experiences.</p>
          </div>
          <div className="grid-3" style={{ gap:'1.5rem' }}>
            {TESTIMONIALS.map((t,i) => (
              <div key={i} className="testimonial-card reveal" style={{ animationDelay:`${i*0.1}s` }}>
                <div style={{ display:'flex', gap:'0.2rem', marginBottom:'1rem' }}>
                  {Array(t.rating).fill(0).map((_,j) => <span key={j} style={{ color:'#F59E0B' }}>★</span>)}
                </div>
                <p className="testimonial-text">"{t.text}"</p>
                <div className="testimonial-author">
                  <img src={t.avatar} alt={t.name} className="testimonial-avatar" />
                  <div>
                    <div className="testimonial-name">{t.name}</div>
                    <div className="testimonial-role">{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ FAQ ══ */}
      <section className="section" style={{ background:'var(--bg)' }}>
        <div className="container">
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1.6fr', gap:'4rem', alignItems:'start' }}>
            <div className="reveal">
              <span className="section-label">Got Questions?</span>
              <h2 className="section-title">Frequently Asked<br/>Questions</h2>
              <div className="divider" />
              <p style={{ lineHeight:1.8, marginBottom:'2rem' }}>Can't find your answer here? Our Kashmir travel experts are available 24/7 to help plan your perfect trip.</p>
              <a href="https://wa.me/919876543210" target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-lg">
                💬 Chat with an Expert
              </a>
            </div>
            <div className="reveal" style={{ animationDelay:'0.1s' }}>
              {FAQS.map((faq,i) => <FaqItem key={i} q={faq.q} a={faq.a} />)}
            </div>
          </div>
        </div>
      </section>

      {/* ══ NEWSLETTER ══ */}
      <section className="section-sm" style={{ background:'var(--bg)', paddingInline:'clamp(1rem,4vw,2.5rem)' }}>
        <div style={{ maxWidth:1320, margin:'0 auto' }}>
          <div className="newsletter-section reveal">
            <div style={{ position:'relative', zIndex:1 }}>
              <span style={{ display:'inline-block', fontFamily:"'Poppins',sans-serif", fontSize:'0.78rem', fontWeight:700, letterSpacing:'0.12em', textTransform:'uppercase', color:'var(--accent)', marginBottom:'0.75rem' }}>✦ Stay Updated</span>
              <h2 style={{ color:'#fff', fontFamily:"'Playfair Display',serif", fontSize:'clamp(1.6rem,3vw,2.4rem)', marginBottom:'0.75rem' }}>
                Get Kashmir Travel Deals<br/><span style={{ fontStyle:'italic', color:'var(--secondary)' }}>Straight to Your Inbox</span>
              </h2>
              <p style={{ color:'rgba(255,255,255,0.75)', maxWidth:480, margin:'0 auto', lineHeight:1.7 }}>
                Early-bird discounts, seasonal offers, and curated itinerary ideas. Join 5,000+ travellers.
              </p>
              <form className="newsletter-form" onSubmit={e => e.preventDefault()}>
                <input className="newsletter-input" type="email" placeholder="Enter your email address" />
                <button className="newsletter-btn" type="submit">Subscribe</button>
              </form>
              <p style={{ color:'rgba(255,255,255,0.50)', fontSize:'0.78rem', marginTop:'1rem' }}>No spam, ever. Unsubscribe anytime.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ══ CTA BANNER ══ */}
      <section style={{ background:'linear-gradient(135deg,#0F4C81,#3AAFA9)', padding:'4rem 0', textAlign:'center' }}>
        <div className="container">
          <h2 style={{ color:'#fff', fontFamily:"'Playfair Display',serif", fontSize:'clamp(1.6rem,3vw,2.4rem)', marginBottom:'1rem' }}>
            Ready to Experience Kashmir?
          </h2>
          <p style={{ color:'rgba(255,255,255,0.85)', maxWidth:500, margin:'0 auto 2rem', lineHeight:1.7 }}>
            Let our experts craft the perfect itinerary for you. Free consultation, no commitment.
          </p>
          <div style={{ display:'flex', gap:'1rem', justifyContent:'center', flexWrap:'wrap' }}>
            <Link to="/tours" className="btn btn-accent btn-lg">Browse All Packages</Link>
            <Link to="/contact" className="btn btn-outline-white btn-lg">Talk to Expert</Link>
          </div>
        </div>
      </section>

      {/* WhatsApp FAB */}
      <a href="https://wa.me/919876543210" target="_blank" rel="noopener noreferrer" className="whatsapp-fab" title="Chat on WhatsApp">
        💬
      </a>

      {/* Scroll Top */}
      <button className={`scroll-top${scrollTop ? ' show' : ''}`} onClick={() => window.scrollTo({ top:0, behavior:'smooth' })} aria-label="Back to top">↑</button>

      <style>{`
        @media (max-width: 900px) {
          .grid-3 { grid-template-columns: 1fr !important; }
          section > .container > div[style*="grid-template-columns: 1fr 1fr"],
          section > .container > div[style*="grid-template-columns: 1fr 1.6fr"] {
            grid-template-columns: 1fr !important;
          }
          .search-widget { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 700px) {
          div[style*="grid-template-columns: repeat(3"] { grid-template-columns: 1fr 1fr !important; }
          div[style*="grid-template-columns: repeat(4"] { grid-template-columns: repeat(2,1fr) !important; }
        }
      `}</style>
    </div>
  );
}
